import { render, staticRenderFns } from "./Statues.vue?vue&type=template&id=3d46f030&scoped=true&"
import script from "./Statues.vue?vue&type=script&lang=js&"
export * from "./Statues.vue?vue&type=script&lang=js&"
import style0 from "./Statues.vue?vue&type=style&index=0&id=3d46f030&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d46f030",
  null
  
)

export default component.exports